import { render, staticRenderFns } from "./not-complete.vue?vue&type=template&id=66006207&"
import script from "./not-complete.vue?vue&type=script&lang=js&"
export * from "./not-complete.vue?vue&type=script&lang=js&"
import style0 from "./not-complete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports